import styled from 'styled-components';

export const BankItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  background: white;
  padding: 24px 20px 24px 20px;
`;
